import { render } from "./DesignPresentation.vue?vue&type=template&id=28c32e94&scoped=true"
import script from "./DesignPresentation.vue?vue&type=script&lang=js"
export * from "./DesignPresentation.vue?vue&type=script&lang=js"

import "./DesignPresentation.vue?vue&type=style&index=0&id=28c32e94&scoped=true&lang=css"
import "./DesignPresentation.vue?vue&type=style&index=1&id=28c32e94&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c32e94"]])

export default __exports__